export default __webpack_public_path__ + "d27ff51cc9d74bcf9d441583dfb22ed7.ttf";